var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.385,
    height: 20,
    viewBox: "1234 345 15.385 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1243.23 345h-7.307a1.923 1.923 0 0 0-1.923 1.923v16.154c0 1.062.861 1.923 1.923 1.923h11.539a1.923 1.923 0 0 0 1.923-1.923v-11.923L1243.23 345Zm-.768 6.923v-5.385l5.384 5.385h-5.384Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon ionic-md-document"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassificationsIcon);
export default __webpack_public_path__ + "static/media/ClassificationsIcon.f5efdaad3baaa9914e9f9ea828e93feb.svg";
export { ForwardRef as ReactComponent };